// Traduções do módulo Programação do cliente, coletadas por glob em core/i18n/messages.ts.
// Sem parêntese nem travessão no texto. Contagem vai como rótulo e valor, que não
// quebra no singular.
export default {
  pt: {
    'programacaoCliente.aindaPrevia': 'Ainda prévia',
    'programacaoCliente.detalhe.cargas': 'Cargas pedidas',
    'programacaoCliente.liberar.liberadasN': 'Liberadas: {{n}} de {{total}}',
    'programacaoCliente.liberar.semConjuntoN': 'Sem conjunto: {{n}}',
    'programacaoCliente.liberar.todasAria': 'Escolher todas com conjunto',
    'programacaoCliente.titulo': 'Programação do cliente',
    'programacaoCliente.eyebrow': 'Logística',
    'programacaoCliente.eyebrowDe': 'Contrato {{contrato}}, {{dia}}',
    'programacaoCliente.naoInformado': 'Não informado',
    'programacaoCliente.abrir': 'Abrir',
    'programacaoCliente.abrirFrente': 'Abrir a Frente',
    'programacaoCliente.salvando': 'Salvando',
    'programacaoCliente.gerando': 'Gerando',
    'programacaoCliente.semDupla': 'Contrato sem dupla',

    'programacaoCliente.col.dia': 'Dia',
    'programacaoCliente.col.contrato': 'Contrato',
    'programacaoCliente.col.fazenda': 'Fazenda',
    'programacaoCliente.col.local': 'Fazenda e destino',
    'programacaoCliente.col.status': 'Programação',
    'programacaoCliente.col.cargas': 'Cargas',
    'programacaoCliente.col.mudancas': 'Mudanças',
    'programacaoCliente.col.pendencias': 'Pendências',
    'programacaoCliente.col.enviada': 'Enviada em',
    'programacaoCliente.col.carga': 'Carga',
    'programacaoCliente.col.pedido': 'Pedido do cliente',
    'programacaoCliente.col.linha': 'Linha da Frente',
    'programacaoCliente.col.conjunto': 'Conjunto escalado',
    'programacaoCliente.col.aoCliente': 'Ao cliente',

    'programacaoCliente.nCargas': 'Cargas pedidas: {{n}}',
    'programacaoCliente.naFrente': 'Na Frente: {{n}}',
    'programacaoCliente.liberadas': 'Liberadas: {{n}}',
    'programacaoCliente.extras': 'Cargas extras: {{n}}',
    'programacaoCliente.reducoes': 'Redução: {{n}}',
    'programacaoCliente.horarios': 'Horários mudados: {{n}}',
    'programacaoCliente.ajustes': 'Ajustes da equipe: {{n}}',
    'programacaoCliente.semMudanca': 'Sem mudança',
    'programacaoCliente.nPendencias': 'Pendências: {{n}}',
    'programacaoCliente.semPendencia': 'Nenhuma',
    'programacaoCliente.dica.naFrente': 'Cargas que já viraram linha na Frente',
    'programacaoCliente.dica.liberadas': 'Cargas com as placas liberadas ao cliente',
    'programacaoCliente.dica.enviada': 'Quando o cliente enviou a programação',
    'programacaoCliente.dica.atualizada': 'A última mudança nas cargas',

    'programacaoCliente.kpi.programacoes': 'Programações',
    'programacaoCliente.kpi.previas': 'Prévias a confirmar',
    'programacaoCliente.kpi.cargas': 'Cargas pedidas',
    'programacaoCliente.kpi.extras': 'Cargas extras',
    'programacaoCliente.kpi.reducoes': 'Redução de carga',
    'programacaoCliente.kpi.reprogramacoes': 'Reprogramações',
    'programacaoCliente.kpi.ajustes': 'Ajustes da equipe',
    'programacaoCliente.kpi.pendencias': 'Com pendência',
    'programacaoCliente.kpi.canceladas': 'Canceladas',

    'programacaoCliente.abasAria': 'Programações por status',
    'programacaoCliente.aba.previa': 'Prévias',
    'programacaoCliente.aba.confirmada': 'Confirmadas',
    'programacaoCliente.aba.todas': 'Todas',
    'programacaoCliente.aba.cancelada': 'Canceladas',
    'programacaoCliente.busca': 'Contrato, produtor, fazenda ou cliente',
    'programacaoCliente.filtro.de': 'De',
    'programacaoCliente.filtro.ate': 'Até',
    'programacaoCliente.filtro.cliente': 'Cliente',
    'programacaoCliente.filtro.dupla': 'Dupla',
    'programacaoCliente.excel': 'Excel',
    'programacaoCliente.semResultado': 'Nenhuma programação do cliente no período.',
    'programacaoCliente.ajuda': 'O que o cliente pediu pelo portal, por dia de carregamento. Nenhuma linha nasce sozinha na Frente: abra a programação e gere as linhas das cargas que quiser. Carga extra é a que entra numa reprogramação ou num ajuste; redução é a que sai, sempre contra a versão anterior. Só conta depois que a programação foi confirmada: a mudança feita na prévia fica no histórico. A confirmada que é cancelada conta todas as cargas como redução.',

    'programacaoCliente.pendencia.horario_divergente': 'Horário diferente na Frente',
    'programacaoCliente.pendencia.saiu_da_programacao': 'Saiu, segue na Frente',
    'programacaoCliente.pendencia.linha_excluida': 'Linha excluída',
    'programacaoCliente.pendencia.liberacao_desatualizada': 'Liberação desatualizada',
    'programacaoCliente.pendenciaDica.horario_divergente': 'O cliente reprogramou depois que a linha foi gerada. A Frente não muda sozinha: ajuste a linha se for o caso.',
    'programacaoCliente.pendenciaDica.saiu_da_programacao': 'O cliente tirou esta carga, e a linha dela continua na Frente. Decida o que fazer com a linha e com a escala.',
    'programacaoCliente.pendenciaDica.linha_excluida': 'A linha gerada para esta carga foi excluída ou cancelada na Frente. Dá para gerar de novo.',
    'programacaoCliente.pendenciaDica.liberacao_desatualizada': 'O conjunto da linha mudou depois da liberação. O cliente ainda vê as placas antigas até você liberar de novo.',
    'programacaoCliente.semConjunto': 'Sem conjunto escalado',
    'programacaoCliente.outraTransportadora': 'Outra transportadora',
    'programacaoCliente.semCavalo': 'Sem cavalo',

    'programacaoCliente.aGerar': 'A gerar',
    'programacaoCliente.linhaAs': 'Na Frente às {{h}}',
    'programacaoCliente.linhaExcluida': 'Linha excluída',
    'programacaoCliente.liberada': 'Liberada ao cliente',
    'programacaoCliente.naoLiberada': 'Não liberada',
    'programacaoCliente.saiuEm': 'Saiu em {{em}}',
    'programacaoCliente.linhaSegue': 'A linha {{linha}} segue na Frente',

    'programacaoCliente.acao.gerar': 'Gerar linhas',
    'programacaoCliente.acao.ajustar': 'Ajustar',
    'programacaoCliente.acao.liberar': 'Liberar ao cliente',
    'programacaoCliente.acao.cancelar': 'Cancelar',
    'programacaoCliente.cancelar.titulo': 'Cancelar a programação?',
    'programacaoCliente.cancelar.texto': 'Todas as cargas saem da programação, e ela fica na lista como cancelada. A linha que já está na Frente continua lá, com a pendência para você decidir.',
    'programacaoCliente.cancelar.contaReducao': 'Estava confirmada: as cargas contam como redução de carga.',
    'programacaoCliente.cancelar.previaNaoConta': 'Era prévia: o cancelamento fica só no histórico.',
    'programacaoCliente.cancelar.motivo': 'Motivo',
    'programacaoCliente.cancelar.motivoDica': 'Quem pediu e por onde, para a conferência com o cliente',
    'programacaoCliente.cancelar.confirmar': 'Cancelar programação',
    'programacaoCliente.cancelar.manter': 'Manter',
    'programacaoCliente.cancelar.feito': 'Programação cancelada.',
    'programacaoCliente.cancelar.cancelando': 'Cancelando',

    'programacaoCliente.detalhe.titulo': 'Programação {{contrato}}',
    'programacaoCliente.detalhe.comPendencia': 'Cargas com pendência: {{n}}',
    'programacaoCliente.detalhe.semPendencia': 'Nenhuma pendência entre o pedido e a Frente.',
    'programacaoCliente.detalhe.zerada': 'O cliente zerou esta programação.',
    'programacaoCliente.detalhe.sairamTitulo': 'Saíram da programação: {{n}}',
    'programacaoCliente.detalhe.historico': 'Histórico',
    'programacaoCliente.detalhe.historicoTexto': 'Cada envio do cliente e cada ação da equipe, do mais recente para o mais antigo.',
    'programacaoCliente.detalhe.situacao': 'Situação',
    'programacaoCliente.detalhe.indicadores': 'Indicadores',

    'programacaoCliente.campo.dia': 'Dia',
    'programacaoCliente.campo.cliente': 'Cliente',
    'programacaoCliente.campo.contrato': 'Contrato',
    'programacaoCliente.campo.fazenda': 'Fazenda',
    'programacaoCliente.campo.destino': 'Destino',
    'programacaoCliente.campo.duplas': 'Dupla',
    'programacaoCliente.campo.enviada': 'Enviada em',
    'programacaoCliente.campo.confirmada': 'Confirmada em',
    'programacaoCliente.campo.cancelada': 'Cancelada em',
    'programacaoCliente.campo.canceladaPor': 'Cancelada por',
    'programacaoCliente.campo.naFrente': 'Na Frente',
    'programacaoCliente.campo.liberadas': 'Liberadas',
    'programacaoCliente.campo.em': 'Em',
    'programacaoCliente.campo.por': 'Por',
    'programacaoCliente.campo.motivo': 'Motivo',

    'programacaoCliente.evento.criacao': 'Programação enviada',
    'programacaoCliente.evento.reprogramacao': 'Reprogramação',
    'programacaoCliente.evento.confirmacao': 'Prévia confirmada',
    'programacaoCliente.evento.ajuste_equipe': 'Ajuste da equipe',
    'programacaoCliente.evento.geracao_frente': 'Linhas geradas na Frente',
    'programacaoCliente.evento.liberacao': 'Placas liberadas ao cliente',
    'programacaoCliente.evento.retirada': 'Placas retiradas do cliente',
    'programacaoCliente.evento.cancelamento': 'Programação cancelada',
    'programacaoCliente.naoConta': 'Na prévia',
    'programacaoCliente.naoContaDica': 'Mudança feita na prévia: fica no histórico e não conta como carga extra nem como redução.',
    'programacaoCliente.canceladasN': 'Canceladas: {{n}}',
    'programacaoCliente.detalhe.canceladaTexto': 'Programação cancelada. As cargas estão em Saíram da programação.',
    'programacaoCliente.origem.cliente': 'Cliente',
    'programacaoCliente.origem.equipe': 'Equipe',
    'programacaoCliente.antes': 'Antes: {{n}}',
    'programacaoCliente.agora': 'Agora: {{n}}',
    'programacaoCliente.pedidas': 'Cargas pedidas: {{n}}',
    'programacaoCliente.nenhuma': 'Nenhuma carga',

    'programacaoCliente.gerar.titulo': 'Gerar linhas na Frente',
    'programacaoCliente.gerar.texto': 'Escolha as cargas do cliente que viram linha na Frente. Cada linha nasce com o contrato, o dia e o horário da carga, igual ao Adicionar carga, e fica ligada a ela.',
    'programacaoCliente.gerar.previa': 'Esta programação ainda é uma prévia. Dá para gerar as linhas, e o cliente pode mudar depois.',
    'programacaoCliente.gerar.nadaAGerar': 'Todas as cargas já estão na Frente.',
    'programacaoCliente.gerar.todas': 'Todas as que faltam: {{n}}',
    'programacaoCliente.gerar.jaNaFrente': 'Na Frente: {{linha}}',
    'programacaoCliente.gerar.escolhidas': 'Escolhidas: {{n}}',
    'programacaoCliente.gerar.botao': 'Gerar linhas: {{n}}',
    'programacaoCliente.gerar.feito': 'Linhas geradas na Frente: {{n}}',

    'programacaoCliente.ajuste.titulo': 'Ajustar pela equipe',
    'programacaoCliente.ajuste.texto': 'Para o pedido que chegou por fora do portal. A carga que entra conta como extra e a que sai como redução, igual à reprogramação do cliente. O cliente vê o ajuste, sem o motivo e sem o print.',
    'programacaoCliente.ajuste.secaoCargas': 'Cargas',
    'programacaoCliente.ajuste.secaoMotivo': 'Motivo',
    'programacaoCliente.ajuste.motivo': 'Motivo do ajuste',
    'programacaoCliente.ajuste.motivoExemplo': 'O cliente pediu mais duas cargas pelo WhatsApp às 21h.',
    'programacaoCliente.ajuste.motivoAjuda': 'Quem pediu, por onde e quando. Fica no histórico da equipe.',
    'programacaoCliente.ajuste.secaoPrint': 'Print da conversa',
    'programacaoCliente.ajuste.printTexto': 'Opcional. O print do pedido do cliente, como prova para o indicador.',
    'programacaoCliente.ajuste.printLimite': 'O ajuste aceita até 10 arquivos.',
    'programacaoCliente.ajuste.salvar': 'Salvar ajuste',
    'programacaoCliente.ajuste.concluir': 'Concluir',
    'programacaoCliente.ajuste.feito': 'Ajuste salvo. O cliente já vê a programação ajustada.',
    'programacaoCliente.ajuste.printFalhou': 'O ajuste foi salvo, mas algum print não subiu. Envie de novo ou conclua sem ele.',
    'programacaoCliente.ajuste.salvoFaltaPrint': 'O ajuste já está salvo. Falta só enviar o print.',
    'programacaoCliente.ajuste.mudou': 'O cliente mexeu na programação enquanto você ajustava. A tela foi atualizada; confira e salve de novo.',
    'programacaoCliente.ajuste.sairTexto': 'O ajuste desta tela ainda não foi salvo.',

    'programacaoCliente.liberar.titulo': 'Liberar ao cliente',
    'programacaoCliente.liberar.texto': 'O cliente vê as placas de cada carga liberada para emitir a nota, sem status e sem mapa. É uma foto: se o conjunto mudar depois, libere de novo.',
    'programacaoCliente.liberar.semLinha': 'Nenhuma carga desta programação está na Frente ainda.',
    'programacaoCliente.liberar.todas': 'Todas com conjunto: {{n}}',
    'programacaoCliente.liberar.escalarNaFrente': 'Escalar na Frente as que faltam: {{n}}',
    'programacaoCliente.liberar.agora': 'Conjunto agora',
    'programacaoCliente.liberar.oClienteVe': 'O cliente vê',
    'programacaoCliente.liberar.em': 'Liberada em {{em}}',
    'programacaoCliente.liberar.botao': 'Liberar ao cliente',
    'programacaoCliente.liberar.retirar': 'Retirar do cliente: {{n}}',
    'programacaoCliente.liberar.retirarTitulo': 'Retirar as placas do cliente?',
    'programacaoCliente.liberar.retirarTexto': 'O cliente deixa de ver as placas das cargas escolhidas. Cargas: {{n}}.',
    'programacaoCliente.liberar.retirarConfirmar': 'Retirar',
    'programacaoCliente.liberar.feito.liberar': 'Placas liberadas ao cliente. Cargas: {{n}}.',
    'programacaoCliente.liberar.feito.retirar': 'Placas retiradas do cliente. Cargas: {{n}}.',

    'programacaoCliente.frente.botao': 'Programação do cliente',
    'programacaoCliente.frente.semProgramacao': 'O cliente não mandou programação deste contrato de hoje em diante',
    'programacaoCliente.frente.titulo': 'Programações do cliente',
    'programacaoCliente.frente.resumo': 'Cargas {{cargas}}, na Frente {{frente}}, liberadas {{liberadas}}',
  },
  en: {
    'programacaoCliente.aindaPrevia': 'Still a preview',
    'programacaoCliente.detalhe.cargas': 'Requested loads',
    'programacaoCliente.liberar.liberadasN': 'Released: {{n}} of {{total}}',
    'programacaoCliente.liberar.semConjuntoN': 'Without a set: {{n}}',
    'programacaoCliente.liberar.todasAria': 'Select all with a set',
    'programacaoCliente.titulo': 'Customer schedule',
    'programacaoCliente.eyebrow': 'Logistics',
    'programacaoCliente.eyebrowDe': 'Contract {{contrato}}, {{dia}}',
    'programacaoCliente.naoInformado': 'Not informed',
    'programacaoCliente.abrir': 'Open',
    'programacaoCliente.abrirFrente': 'Open the Work Front',
    'programacaoCliente.salvando': 'Saving',
    'programacaoCliente.gerando': 'Generating',
    'programacaoCliente.semDupla': 'Contract without pair',

    'programacaoCliente.col.dia': 'Day',
    'programacaoCliente.col.contrato': 'Contract',
    'programacaoCliente.col.fazenda': 'Farm',
    'programacaoCliente.col.local': 'Farm and destination',
    'programacaoCliente.col.status': 'Schedule',
    'programacaoCliente.col.cargas': 'Loads',
    'programacaoCliente.col.mudancas': 'Changes',
    'programacaoCliente.col.pendencias': 'Issues',
    'programacaoCliente.col.enviada': 'Sent at',
    'programacaoCliente.col.carga': 'Load',
    'programacaoCliente.col.pedido': 'Customer request',
    'programacaoCliente.col.linha': 'Work Front line',
    'programacaoCliente.col.conjunto': 'Scheduled set',
    'programacaoCliente.col.aoCliente': 'To the customer',

    'programacaoCliente.nCargas': 'Loads requested: {{n}}',
    'programacaoCliente.naFrente': 'On the Work Front: {{n}}',
    'programacaoCliente.liberadas': 'Released: {{n}}',
    'programacaoCliente.extras': 'Extra loads: {{n}}',
    'programacaoCliente.reducoes': 'Reduction: {{n}}',
    'programacaoCliente.horarios': 'Times changed: {{n}}',
    'programacaoCliente.ajustes': 'Team adjustments: {{n}}',
    'programacaoCliente.semMudanca': 'No change',
    'programacaoCliente.nPendencias': 'Issues: {{n}}',
    'programacaoCliente.semPendencia': 'None',
    'programacaoCliente.dica.naFrente': 'Loads that already became a Work Front line',
    'programacaoCliente.dica.liberadas': 'Loads with the plates released to the customer',
    'programacaoCliente.dica.enviada': 'When the customer sent the schedule',
    'programacaoCliente.dica.atualizada': 'The last change to the loads',

    'programacaoCliente.kpi.programacoes': 'Schedules',
    'programacaoCliente.kpi.previas': 'Previews to confirm',
    'programacaoCliente.kpi.cargas': 'Loads requested',
    'programacaoCliente.kpi.extras': 'Extra loads',
    'programacaoCliente.kpi.reducoes': 'Load reduction',
    'programacaoCliente.kpi.reprogramacoes': 'Reschedules',
    'programacaoCliente.kpi.ajustes': 'Team adjustments',
    'programacaoCliente.kpi.pendencias': 'With issues',
    'programacaoCliente.kpi.canceladas': 'Cancelled',

    'programacaoCliente.abasAria': 'Schedules by status',
    'programacaoCliente.aba.previa': 'Previews',
    'programacaoCliente.aba.confirmada': 'Confirmed',
    'programacaoCliente.aba.todas': 'All',
    'programacaoCliente.aba.cancelada': 'Cancelled',
    'programacaoCliente.busca': 'Contract, producer, farm or customer',
    'programacaoCliente.filtro.de': 'From',
    'programacaoCliente.filtro.ate': 'To',
    'programacaoCliente.filtro.cliente': 'Customer',
    'programacaoCliente.filtro.dupla': 'Pair',
    'programacaoCliente.excel': 'Excel',
    'programacaoCliente.semResultado': 'No customer schedule in the period.',
    'programacaoCliente.ajuda': 'What the customer requested through the portal, by loading day. No line is created on the Work Front by itself: open the schedule and generate the lines of the loads you want. An extra load is one added in a reschedule or an adjustment; a reduction is one removed, always against the previous version. It only counts after the schedule is confirmed: a change made in the preview stays in the history. A confirmed schedule that is cancelled counts every load as a reduction.',

    'programacaoCliente.pendencia.horario_divergente': 'Different time on the Work Front',
    'programacaoCliente.pendencia.saiu_da_programacao': 'Removed, still on the Work Front',
    'programacaoCliente.pendencia.linha_excluida': 'Line deleted',
    'programacaoCliente.pendencia.liberacao_desatualizada': 'Release outdated',
    'programacaoCliente.pendenciaDica.horario_divergente': 'The customer rescheduled after the line was generated. The Work Front does not change by itself: adjust the line if needed.',
    'programacaoCliente.pendenciaDica.saiu_da_programacao': 'The customer removed this load, and its line is still on the Work Front. Decide what to do with the line and the schedule.',
    'programacaoCliente.pendenciaDica.linha_excluida': 'The line generated for this load was deleted or cancelled on the Work Front. You can generate it again.',
    'programacaoCliente.pendenciaDica.liberacao_desatualizada': 'The line set changed after the release. The customer still sees the old plates until you release again.',
    'programacaoCliente.semConjunto': 'No set scheduled',
    'programacaoCliente.outraTransportadora': 'Other carrier',
    'programacaoCliente.semCavalo': 'No truck',

    'programacaoCliente.aGerar': 'To generate',
    'programacaoCliente.linhaAs': 'On the Work Front at {{h}}',
    'programacaoCliente.linhaExcluida': 'Line deleted',
    'programacaoCliente.liberada': 'Released to the customer',
    'programacaoCliente.naoLiberada': 'Not released',
    'programacaoCliente.saiuEm': 'Removed at {{em}}',
    'programacaoCliente.linhaSegue': 'Line {{linha}} is still on the Work Front',

    'programacaoCliente.acao.gerar': 'Generate lines',
    'programacaoCliente.acao.ajustar': 'Adjust',
    'programacaoCliente.acao.liberar': 'Release to customer',
    'programacaoCliente.acao.cancelar': 'Cancel',
    'programacaoCliente.cancelar.titulo': 'Cancel the schedule?',
    'programacaoCliente.cancelar.texto': 'Every load leaves the schedule, and it stays on the list as cancelled. A line already on the Work Front stays there, flagged for you to decide.',
    'programacaoCliente.cancelar.contaReducao': 'It was confirmed: the loads count as load reduction.',
    'programacaoCliente.cancelar.previaNaoConta': 'It was a preview: the cancellation only goes to the history.',
    'programacaoCliente.cancelar.motivo': 'Reason',
    'programacaoCliente.cancelar.motivoDica': 'Who asked and how, for the check with the customer',
    'programacaoCliente.cancelar.confirmar': 'Cancel schedule',
    'programacaoCliente.cancelar.manter': 'Keep',
    'programacaoCliente.cancelar.feito': 'Schedule cancelled.',
    'programacaoCliente.cancelar.cancelando': 'Cancelling',

    'programacaoCliente.detalhe.titulo': 'Schedule {{contrato}}',
    'programacaoCliente.detalhe.comPendencia': 'Loads with issues: {{n}}',
    'programacaoCliente.detalhe.semPendencia': 'No issue between the request and the Work Front.',
    'programacaoCliente.detalhe.zerada': 'The customer cleared this schedule.',
    'programacaoCliente.detalhe.sairamTitulo': 'Removed from the schedule: {{n}}',
    'programacaoCliente.detalhe.historico': 'History',
    'programacaoCliente.detalhe.historicoTexto': 'Each customer submission and each team action, newest first.',
    'programacaoCliente.detalhe.situacao': 'Status',
    'programacaoCliente.detalhe.indicadores': 'Indicators',

    'programacaoCliente.campo.dia': 'Day',
    'programacaoCliente.campo.cliente': 'Customer',
    'programacaoCliente.campo.contrato': 'Contract',
    'programacaoCliente.campo.fazenda': 'Farm',
    'programacaoCliente.campo.destino': 'Destination',
    'programacaoCliente.campo.duplas': 'Pair',
    'programacaoCliente.campo.enviada': 'Sent at',
    'programacaoCliente.campo.confirmada': 'Confirmed at',
    'programacaoCliente.campo.cancelada': 'Cancelled at',
    'programacaoCliente.campo.canceladaPor': 'Cancelled by',
    'programacaoCliente.campo.naFrente': 'On the Work Front',
    'programacaoCliente.campo.liberadas': 'Released',
    'programacaoCliente.campo.em': 'At',
    'programacaoCliente.campo.por': 'By',
    'programacaoCliente.campo.motivo': 'Reason',

    'programacaoCliente.evento.criacao': 'Schedule sent',
    'programacaoCliente.evento.reprogramacao': 'Reschedule',
    'programacaoCliente.evento.confirmacao': 'Preview confirmed',
    'programacaoCliente.evento.ajuste_equipe': 'Team adjustment',
    'programacaoCliente.evento.geracao_frente': 'Lines generated on the Work Front',
    'programacaoCliente.evento.liberacao': 'Plates released to the customer',
    'programacaoCliente.evento.retirada': 'Plates withdrawn from the customer',
    'programacaoCliente.evento.cancelamento': 'Schedule cancelled',
    'programacaoCliente.naoConta': 'In preview',
    'programacaoCliente.naoContaDica': 'Change made in the preview: it stays in the history and does not count as extra load or reduction.',
    'programacaoCliente.canceladasN': 'Cancelled: {{n}}',
    'programacaoCliente.detalhe.canceladaTexto': 'Schedule cancelled. The loads are under Removed from the schedule.',
    'programacaoCliente.origem.cliente': 'Customer',
    'programacaoCliente.origem.equipe': 'Team',
    'programacaoCliente.antes': 'Before: {{n}}',
    'programacaoCliente.agora': 'Now: {{n}}',
    'programacaoCliente.pedidas': 'Loads requested: {{n}}',
    'programacaoCliente.nenhuma': 'No loads',

    'programacaoCliente.gerar.titulo': 'Generate Work Front lines',
    'programacaoCliente.gerar.texto': 'Pick the customer loads that become a Work Front line. Each line is created with the contract, the day and the time of the load, like Add load, and stays linked to it.',
    'programacaoCliente.gerar.previa': 'This schedule is still a preview. You can generate the lines, and the customer may change it later.',
    'programacaoCliente.gerar.nadaAGerar': 'All loads are already on the Work Front.',
    'programacaoCliente.gerar.todas': 'All remaining: {{n}}',
    'programacaoCliente.gerar.jaNaFrente': 'On the Work Front: {{linha}}',
    'programacaoCliente.gerar.escolhidas': 'Selected: {{n}}',
    'programacaoCliente.gerar.botao': 'Generate lines: {{n}}',
    'programacaoCliente.gerar.feito': 'Lines generated on the Work Front: {{n}}',

    'programacaoCliente.ajuste.titulo': 'Adjust as the team',
    'programacaoCliente.ajuste.texto': 'For the request that came outside the portal. The load added counts as extra and the one removed as reduction, like the customer reschedule. The customer sees the adjustment, without the reason and without the screenshot.',
    'programacaoCliente.ajuste.secaoCargas': 'Loads',
    'programacaoCliente.ajuste.secaoMotivo': 'Reason',
    'programacaoCliente.ajuste.motivo': 'Adjustment reason',
    'programacaoCliente.ajuste.motivoExemplo': 'The customer asked for two more loads on WhatsApp at 9 pm.',
    'programacaoCliente.ajuste.motivoAjuda': 'Who asked, through what and when. It stays in the team history.',
    'programacaoCliente.ajuste.secaoPrint': 'Conversation screenshot',
    'programacaoCliente.ajuste.printTexto': 'Optional. The screenshot of the customer request, as proof for the indicator.',
    'programacaoCliente.ajuste.printLimite': 'The adjustment accepts up to 10 files.',
    'programacaoCliente.ajuste.salvar': 'Save adjustment',
    'programacaoCliente.ajuste.concluir': 'Done',
    'programacaoCliente.ajuste.feito': 'Adjustment saved. The customer already sees the adjusted schedule.',
    'programacaoCliente.ajuste.printFalhou': 'The adjustment was saved, but some screenshot did not upload. Send it again or finish without it.',
    'programacaoCliente.ajuste.salvoFaltaPrint': 'The adjustment is saved. Only the screenshot is left.',
    'programacaoCliente.ajuste.mudou': 'The customer changed the schedule while you were adjusting. The screen was refreshed; check it and save again.',
    'programacaoCliente.ajuste.sairTexto': 'The adjustment on this screen has not been saved.',

    'programacaoCliente.liberar.titulo': 'Release to the customer',
    'programacaoCliente.liberar.texto': 'The customer sees the plates of each released load to issue the invoice, without status and without map. It is a snapshot: if the set changes later, release again.',
    'programacaoCliente.liberar.semLinha': 'No load of this schedule is on the Work Front yet.',
    'programacaoCliente.liberar.todas': 'All with a set: {{n}}',
    'programacaoCliente.liberar.escalarNaFrente': 'Schedule the missing ones on the Work Front: {{n}}',
    'programacaoCliente.liberar.agora': 'Set now',
    'programacaoCliente.liberar.oClienteVe': 'The customer sees',
    'programacaoCliente.liberar.em': 'Released at {{em}}',
    'programacaoCliente.liberar.botao': 'Release to the customer',
    'programacaoCliente.liberar.retirar': 'Withdraw from the customer: {{n}}',
    'programacaoCliente.liberar.retirarTitulo': 'Withdraw the plates from the customer?',
    'programacaoCliente.liberar.retirarTexto': 'The customer stops seeing the plates of the selected loads. Loads: {{n}}.',
    'programacaoCliente.liberar.retirarConfirmar': 'Withdraw',
    'programacaoCliente.liberar.feito.liberar': 'Plates released to the customer. Loads: {{n}}.',
    'programacaoCliente.liberar.feito.retirar': 'Plates withdrawn from the customer. Loads: {{n}}.',

    'programacaoCliente.frente.botao': 'Customer schedule',
    'programacaoCliente.frente.semProgramacao': 'The customer has not sent a schedule for this contract from today on',
    'programacaoCliente.frente.titulo': 'Customer schedules',
    'programacaoCliente.frente.resumo': 'Loads {{cargas}}, on the Work Front {{frente}}, released {{liberadas}}',
  },
  es: {
    'programacaoCliente.aindaPrevia': 'Todavía previa',
    'programacaoCliente.detalhe.cargas': 'Cargas pedidas',
    'programacaoCliente.liberar.liberadasN': 'Liberadas: {{n}} de {{total}}',
    'programacaoCliente.liberar.semConjuntoN': 'Sin conjunto: {{n}}',
    'programacaoCliente.liberar.todasAria': 'Elegir todas con conjunto',
    'programacaoCliente.titulo': 'Programación del cliente',
    'programacaoCliente.eyebrow': 'Logística',
    'programacaoCliente.eyebrowDe': 'Contrato {{contrato}}, {{dia}}',
    'programacaoCliente.naoInformado': 'No informado',
    'programacaoCliente.abrir': 'Abrir',
    'programacaoCliente.abrirFrente': 'Abrir el Frente',
    'programacaoCliente.salvando': 'Guardando',
    'programacaoCliente.gerando': 'Generando',
    'programacaoCliente.semDupla': 'Contrato sin dupla',

    'programacaoCliente.col.dia': 'Día',
    'programacaoCliente.col.contrato': 'Contrato',
    'programacaoCliente.col.fazenda': 'Hacienda',
    'programacaoCliente.col.local': 'Hacienda y destino',
    'programacaoCliente.col.status': 'Programación',
    'programacaoCliente.col.cargas': 'Cargas',
    'programacaoCliente.col.mudancas': 'Cambios',
    'programacaoCliente.col.pendencias': 'Pendencias',
    'programacaoCliente.col.enviada': 'Enviada el',
    'programacaoCliente.col.carga': 'Carga',
    'programacaoCliente.col.pedido': 'Pedido del cliente',
    'programacaoCliente.col.linha': 'Línea del Frente',
    'programacaoCliente.col.conjunto': 'Conjunto asignado',
    'programacaoCliente.col.aoCliente': 'Al cliente',

    'programacaoCliente.nCargas': 'Cargas pedidas: {{n}}',
    'programacaoCliente.naFrente': 'En el Frente: {{n}}',
    'programacaoCliente.liberadas': 'Liberadas: {{n}}',
    'programacaoCliente.extras': 'Cargas extra: {{n}}',
    'programacaoCliente.reducoes': 'Reducción: {{n}}',
    'programacaoCliente.horarios': 'Horarios cambiados: {{n}}',
    'programacaoCliente.ajustes': 'Ajustes del equipo: {{n}}',
    'programacaoCliente.semMudanca': 'Sin cambio',
    'programacaoCliente.nPendencias': 'Pendencias: {{n}}',
    'programacaoCliente.semPendencia': 'Ninguna',
    'programacaoCliente.dica.naFrente': 'Cargas que ya son línea en el Frente',
    'programacaoCliente.dica.liberadas': 'Cargas con las placas liberadas al cliente',
    'programacaoCliente.dica.enviada': 'Cuando el cliente envió la programación',
    'programacaoCliente.dica.atualizada': 'El último cambio en las cargas',

    'programacaoCliente.kpi.programacoes': 'Programaciones',
    'programacaoCliente.kpi.previas': 'Previas a confirmar',
    'programacaoCliente.kpi.cargas': 'Cargas pedidas',
    'programacaoCliente.kpi.extras': 'Cargas extra',
    'programacaoCliente.kpi.reducoes': 'Reducción de carga',
    'programacaoCliente.kpi.reprogramacoes': 'Reprogramaciones',
    'programacaoCliente.kpi.ajustes': 'Ajustes del equipo',
    'programacaoCliente.kpi.pendencias': 'Con pendencia',
    'programacaoCliente.kpi.canceladas': 'Canceladas',

    'programacaoCliente.abasAria': 'Programaciones por estado',
    'programacaoCliente.aba.previa': 'Previas',
    'programacaoCliente.aba.confirmada': 'Confirmadas',
    'programacaoCliente.aba.todas': 'Todas',
    'programacaoCliente.aba.cancelada': 'Canceladas',
    'programacaoCliente.busca': 'Contrato, productor, hacienda o cliente',
    'programacaoCliente.filtro.de': 'Desde',
    'programacaoCliente.filtro.ate': 'Hasta',
    'programacaoCliente.filtro.cliente': 'Cliente',
    'programacaoCliente.filtro.dupla': 'Dupla',
    'programacaoCliente.excel': 'Excel',
    'programacaoCliente.semResultado': 'Ninguna programación del cliente en el período.',
    'programacaoCliente.ajuda': 'Lo que el cliente pidió por el portal, por día de carga. Ninguna línea nace sola en el Frente: abra la programación y genere las líneas de las cargas que quiera. Carga extra es la que entra en una reprogramación o en un ajuste; reducción es la que sale, siempre contra la versión anterior. Solo cuenta después de que la programación fue confirmada: el cambio hecho en la previa queda en el historial. La confirmada que se cancela cuenta todas las cargas como reducción.',

    'programacaoCliente.pendencia.horario_divergente': 'Horario distinto en el Frente',
    'programacaoCliente.pendencia.saiu_da_programacao': 'Salió, sigue en el Frente',
    'programacaoCliente.pendencia.linha_excluida': 'Línea eliminada',
    'programacaoCliente.pendencia.liberacao_desatualizada': 'Liberación desactualizada',
    'programacaoCliente.pendenciaDica.horario_divergente': 'El cliente reprogramó después de que se generó la línea. El Frente no cambia solo: ajuste la línea si corresponde.',
    'programacaoCliente.pendenciaDica.saiu_da_programacao': 'El cliente quitó esta carga, y su línea sigue en el Frente. Decida qué hacer con la línea y con la escala.',
    'programacaoCliente.pendenciaDica.linha_excluida': 'La línea generada para esta carga fue eliminada o cancelada en el Frente. Se puede generar de nuevo.',
    'programacaoCliente.pendenciaDica.liberacao_desatualizada': 'El conjunto de la línea cambió después de la liberación. El cliente sigue viendo las placas viejas hasta que usted libere de nuevo.',
    'programacaoCliente.semConjunto': 'Sin conjunto asignado',
    'programacaoCliente.outraTransportadora': 'Otra transportadora',
    'programacaoCliente.semCavalo': 'Sin tractor',

    'programacaoCliente.aGerar': 'Por generar',
    'programacaoCliente.linhaAs': 'En el Frente a las {{h}}',
    'programacaoCliente.linhaExcluida': 'Línea eliminada',
    'programacaoCliente.liberada': 'Liberada al cliente',
    'programacaoCliente.naoLiberada': 'No liberada',
    'programacaoCliente.saiuEm': 'Salió el {{em}}',
    'programacaoCliente.linhaSegue': 'La línea {{linha}} sigue en el Frente',

    'programacaoCliente.acao.gerar': 'Generar líneas',
    'programacaoCliente.acao.ajustar': 'Ajustar',
    'programacaoCliente.acao.liberar': 'Liberar al cliente',
    'programacaoCliente.acao.cancelar': 'Cancelar',
    'programacaoCliente.cancelar.titulo': '¿Cancelar la programación?',
    'programacaoCliente.cancelar.texto': 'Todas las cargas salen de la programación, y queda en la lista como cancelada. La línea que ya está en el Frente sigue allí, con la pendencia para que usted decida.',
    'programacaoCliente.cancelar.contaReducao': 'Estaba confirmada: las cargas cuentan como reducción de carga.',
    'programacaoCliente.cancelar.previaNaoConta': 'Era previa: la cancelación queda solo en el historial.',
    'programacaoCliente.cancelar.motivo': 'Motivo',
    'programacaoCliente.cancelar.motivoDica': 'Quién pidió y por dónde, para la conferencia con el cliente',
    'programacaoCliente.cancelar.confirmar': 'Cancelar programación',
    'programacaoCliente.cancelar.manter': 'Mantener',
    'programacaoCliente.cancelar.feito': 'Programación cancelada.',
    'programacaoCliente.cancelar.cancelando': 'Cancelando',

    'programacaoCliente.detalhe.titulo': 'Programación {{contrato}}',
    'programacaoCliente.detalhe.comPendencia': 'Cargas con pendencia: {{n}}',
    'programacaoCliente.detalhe.semPendencia': 'Ninguna pendencia entre el pedido y el Frente.',
    'programacaoCliente.detalhe.zerada': 'El cliente dejó esta programación en cero.',
    'programacaoCliente.detalhe.sairamTitulo': 'Salieron de la programación: {{n}}',
    'programacaoCliente.detalhe.historico': 'Historial',
    'programacaoCliente.detalhe.historicoTexto': 'Cada envío del cliente y cada acción del equipo, del más reciente al más antiguo.',
    'programacaoCliente.detalhe.situacao': 'Situación',
    'programacaoCliente.detalhe.indicadores': 'Indicadores',

    'programacaoCliente.campo.dia': 'Día',
    'programacaoCliente.campo.cliente': 'Cliente',
    'programacaoCliente.campo.contrato': 'Contrato',
    'programacaoCliente.campo.fazenda': 'Hacienda',
    'programacaoCliente.campo.destino': 'Destino',
    'programacaoCliente.campo.duplas': 'Dupla',
    'programacaoCliente.campo.enviada': 'Enviada el',
    'programacaoCliente.campo.confirmada': 'Confirmada el',
    'programacaoCliente.campo.cancelada': 'Cancelada el',
    'programacaoCliente.campo.canceladaPor': 'Cancelada por',
    'programacaoCliente.campo.naFrente': 'En el Frente',
    'programacaoCliente.campo.liberadas': 'Liberadas',
    'programacaoCliente.campo.em': 'El',
    'programacaoCliente.campo.por': 'Por',
    'programacaoCliente.campo.motivo': 'Motivo',

    'programacaoCliente.evento.criacao': 'Programación enviada',
    'programacaoCliente.evento.reprogramacao': 'Reprogramación',
    'programacaoCliente.evento.confirmacao': 'Previa confirmada',
    'programacaoCliente.evento.ajuste_equipe': 'Ajuste del equipo',
    'programacaoCliente.evento.geracao_frente': 'Líneas generadas en el Frente',
    'programacaoCliente.evento.liberacao': 'Placas liberadas al cliente',
    'programacaoCliente.evento.retirada': 'Placas retiradas del cliente',
    'programacaoCliente.evento.cancelamento': 'Programación cancelada',
    'programacaoCliente.naoConta': 'En la previa',
    'programacaoCliente.naoContaDica': 'Cambio hecho en la previa: queda en el historial y no cuenta como carga extra ni como reducción.',
    'programacaoCliente.canceladasN': 'Canceladas: {{n}}',
    'programacaoCliente.detalhe.canceladaTexto': 'Programación cancelada. Las cargas están en Salieron de la programación.',
    'programacaoCliente.origem.cliente': 'Cliente',
    'programacaoCliente.origem.equipe': 'Equipo',
    'programacaoCliente.antes': 'Antes: {{n}}',
    'programacaoCliente.agora': 'Ahora: {{n}}',
    'programacaoCliente.pedidas': 'Cargas pedidas: {{n}}',
    'programacaoCliente.nenhuma': 'Ninguna carga',

    'programacaoCliente.gerar.titulo': 'Generar líneas en el Frente',
    'programacaoCliente.gerar.texto': 'Elija las cargas del cliente que se vuelven línea en el Frente. Cada línea nace con el contrato, el día y el horario de la carga, igual que Agregar carga, y queda ligada a ella.',
    'programacaoCliente.gerar.previa': 'Esta programación todavía es una previa. Se pueden generar las líneas, y el cliente puede cambiarla después.',
    'programacaoCliente.gerar.nadaAGerar': 'Todas las cargas ya están en el Frente.',
    'programacaoCliente.gerar.todas': 'Todas las que faltan: {{n}}',
    'programacaoCliente.gerar.jaNaFrente': 'En el Frente: {{linha}}',
    'programacaoCliente.gerar.escolhidas': 'Elegidas: {{n}}',
    'programacaoCliente.gerar.botao': 'Generar líneas: {{n}}',
    'programacaoCliente.gerar.feito': 'Líneas generadas en el Frente: {{n}}',

    'programacaoCliente.ajuste.titulo': 'Ajustar por el equipo',
    'programacaoCliente.ajuste.texto': 'Para el pedido que llegó por fuera del portal. La carga que entra cuenta como extra y la que sale como reducción, igual que la reprogramación del cliente. El cliente ve el ajuste, sin el motivo y sin la captura.',
    'programacaoCliente.ajuste.secaoCargas': 'Cargas',
    'programacaoCliente.ajuste.secaoMotivo': 'Motivo',
    'programacaoCliente.ajuste.motivo': 'Motivo del ajuste',
    'programacaoCliente.ajuste.motivoExemplo': 'El cliente pidió dos cargas más por WhatsApp a las 21h.',
    'programacaoCliente.ajuste.motivoAjuda': 'Quién pidió, por dónde y cuándo. Queda en el historial del equipo.',
    'programacaoCliente.ajuste.secaoPrint': 'Captura de la conversación',
    'programacaoCliente.ajuste.printTexto': 'Opcional. La captura del pedido del cliente, como prueba para el indicador.',
    'programacaoCliente.ajuste.printLimite': 'El ajuste acepta hasta 10 archivos.',
    'programacaoCliente.ajuste.salvar': 'Guardar ajuste',
    'programacaoCliente.ajuste.concluir': 'Concluir',
    'programacaoCliente.ajuste.feito': 'Ajuste guardado. El cliente ya ve la programación ajustada.',
    'programacaoCliente.ajuste.printFalhou': 'El ajuste se guardó, pero alguna captura no subió. Envíela de nuevo o concluya sin ella.',
    'programacaoCliente.ajuste.salvoFaltaPrint': 'El ajuste ya está guardado. Falta solo enviar la captura.',
    'programacaoCliente.ajuste.mudou': 'El cliente cambió la programación mientras usted ajustaba. La pantalla se actualizó; revise y guarde de nuevo.',
    'programacaoCliente.ajuste.sairTexto': 'El ajuste de esta pantalla todavía no fue guardado.',

    'programacaoCliente.liberar.titulo': 'Liberar al cliente',
    'programacaoCliente.liberar.texto': 'El cliente ve las placas de cada carga liberada para emitir la factura, sin estado y sin mapa. Es una foto: si el conjunto cambia después, libere de nuevo.',
    'programacaoCliente.liberar.semLinha': 'Ninguna carga de esta programación está en el Frente todavía.',
    'programacaoCliente.liberar.todas': 'Todas con conjunto: {{n}}',
    'programacaoCliente.liberar.escalarNaFrente': 'Asignar en el Frente las que faltan: {{n}}',
    'programacaoCliente.liberar.agora': 'Conjunto ahora',
    'programacaoCliente.liberar.oClienteVe': 'El cliente ve',
    'programacaoCliente.liberar.em': 'Liberada el {{em}}',
    'programacaoCliente.liberar.botao': 'Liberar al cliente',
    'programacaoCliente.liberar.retirar': 'Retirar del cliente: {{n}}',
    'programacaoCliente.liberar.retirarTitulo': '¿Retirar las placas del cliente?',
    'programacaoCliente.liberar.retirarTexto': 'El cliente deja de ver las placas de las cargas elegidas. Cargas: {{n}}.',
    'programacaoCliente.liberar.retirarConfirmar': 'Retirar',
    'programacaoCliente.liberar.feito.liberar': 'Placas liberadas al cliente. Cargas: {{n}}.',
    'programacaoCliente.liberar.feito.retirar': 'Placas retiradas del cliente. Cargas: {{n}}.',

    'programacaoCliente.frente.botao': 'Programación del cliente',
    'programacaoCliente.frente.semProgramacao': 'El cliente no envió programación de este contrato de hoy en adelante',
    'programacaoCliente.frente.titulo': 'Programaciones del cliente',
    'programacaoCliente.frente.resumo': 'Cargas {{cargas}}, en el Frente {{frente}}, liberadas {{liberadas}}',
  },
}
